import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
export var Date = function (options) { return (React.createElement(Moment, { date: moment.utc(options.date), format: options.format })); };
//# sourceMappingURL=Date.js.map